import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FieldItem } from 'src/app/models/common/field-item';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { ProductionServiceHandler } from './production.service.handler';

@Injectable({
  providedIn: 'root',
})
export class ProductionService extends ProductionServiceHandler {
  // getOutputPreferences(ref_id: any) {
  //   throw new Error('Method not implemented.');
  // }
  constructor(http: HttpClient, settingService: SettingService) {
    super(http, settingService);
  }
}
